import { Link, NavLink, Outlet, redirect, useLocation } from 'react-router-dom';
import { Avatar } from 'antd';
import {
  CompassOutlined,
  EnvironmentOutlined,
  FireOutlined,
  UserOutlined,
} from '@ant-design/icons';
import { createContact } from '../contacts';
import { useAuth } from '../hooks/useAuth';
import InviteNotificationBadge from '../components/campaign/InviteNotificationBadge';

const backendUrl = process.env.REACT_APP_BACKEND;
const providersNames = ['strava'];
const navItems = [
  { to: '/', label: 'Khám phá', icon: <CompassOutlined /> },
  { to: '/map', label: 'Bản đồ', icon: <EnvironmentOutlined />, matchMap: true },
  { to: '/activity', label: 'Hoạt động', icon: <FireOutlined /> },
  { to: '/profile', label: 'Hồ sơ', icon: <UserOutlined /> },
];

const LoginButton = ({ providerName }) => (
  <a className="nav-item btn btn-primary btn-signup" href={`${backendUrl}/api/connect/${providerName}`}>
    Đăng nhập với {providerName}
  </a>
);

export async function action() {
  const contact = await createContact();
  return redirect(`/contacts/${contact.id}/edit`);
}

export async function loader() {
  return {};
}

export default function Root() {
  const { user, isLoggedIn, logout } = useAuth();
  const location = useLocation();
  const userData = user?.user;
  const navClassName = (item) => ({ isActive }) => (
    isActive || (item.matchMap && location.pathname.includes('/map')) ? 'active' : undefined
  );

  return (
    <div className="htv-app-shell">
      <header className="htv-topbar">
        <Link className="htv-brand" to="/">
          {/* <span className="htv-brand-mark">DLC</span> */}
          <img className="htv-brand-mark" src="/logo512.png" alt="CIO Coaching Running CLub" />
          <span>
            <strong>CIO Coaching</strong>
            <small>Running CLub</small>
          </span>
        </Link>

        <nav className="htv-desktop-nav" aria-label="Primary">
          {navItems.map((item) => (
            <NavLink className={navClassName(item)} key={item.to} to={item.to}>
              {item.label}
            </NavLink>
          ))}
        </nav>

        {isLoggedIn ? (
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <InviteNotificationBadge />
            <Link className="htv-user-chip" to="/profile">
              {userData?.avatar ? (
                <img alt={userData?.name || 'User'} src={userData.avatar} />
              ) : (
                <Avatar size={28} icon={<UserOutlined />} />
              )}
              <span className="htv-user-name">{userData?.name || 'Athlete'}</span>
            </Link>
          </div>
        ) : (
          <div className="htv-login-area">
            {providersNames.map((providerName) => (
              <LoginButton key={providerName} providerName={providerName} />
            ))}
          </div>
        )}
      </header>

      <main className="htv-page">
        <Outlet />
      </main>

      <footer className="htv-legal-footer" aria-label="Legal links">
        <span>CIOC Running Club</span>
        <div className="htv-legal-links">
          <Link to="/terms-and-conditions">Terms &amp; Conditions</Link>
          <Link to="/privacy-policy">Privacy Policy</Link>
        </div>
      </footer>

      <nav className="htv-bottom-nav" aria-label="Mobile primary">
        {navItems.map((item) => (
          <NavLink className={navClassName(item)} key={item.to} to={item.to}>
            {item.icon}
            <span className="htv-nav-label">{item.label}</span>
          </NavLink>
        ))}
      </nav>
    </div>
  );
}
